var angular = require('angular');
var app = angular.module('learn-directives');

import React from 'react';
import { createRoot } from 'react-dom/client';
import Layout from '../chart-overview-app';

const layoutVars = {
  reportBaseUrl: null,
  authToken: null,
  countryLocale: null,
};

function renderLayout(root, layoutVars) {
  root.render(<Layout {...layoutVars} />);
}

const reactDirective = app.directive('chartOverviewDirective', [
  function () {
    return {
      template: '<div id="chart-overview-app" class="react-part">Charts</div>',
      scope: {
        reportBaseUrl: '=',
        authToken: '=',
        countryLocale: '=',
      },
      link: function (scope, el, attrs) {
        const reactapp = document.getElementById('chart-overview-app');
        const root = createRoot(reactapp);
        layoutVars.authToken = scope.authToken;
        layoutVars.reportBaseUrl = scope.reportBaseUrl;
        layoutVars.countryLocale = scope.countryLocale;
        // We know these will all be populated by the time we get here as part of Application setup,
        //   so it's safe to render.
        renderLayout(root, layoutVars);

        scope.$watch(
          'reportBaseUrl',
          function (newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue !== oldValue) {
              layoutVars.reportBaseUrl = newValue;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'authToken',
          function (newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue !== oldValue) {
              layoutVars.authToken = newValue;
              renderLayout(root, layoutVars);
            }
          },
          true
        );

        scope.$watch(
          'countryLocale',
          function (newValue, oldValue) {
            if (angular.isDefined(newValue) && newValue !== oldValue) {
              layoutVars.countryLocale = newValue;
              renderLayout(root, layoutVars);
            }
          },
          true
        );
      },
    };
  },
]);

export default reactDirective;
